module.exports = "../../../../platform/assets/pageMainIcon/business_.svg";